import { PageLayoutMenuFooter as PageLayoutMenuFooterLib } from '@ferreri/prever-component-lib';
import { ReactNode } from 'react';
import { ClubeMenu } from '../menus/ClubeMenu';

export type PageLayoutMenuProps = {
  children: ReactNode;
  title?: string;
};

export const PageLayoutMenuFooter = (props: PageLayoutMenuProps) => (
  <PageLayoutMenuFooterLib sideMenu={<ClubeMenu />} title={props.title}>
    {props.children}
  </PageLayoutMenuFooterLib>
);
